
import { defineComponent, onBeforeUnmount, onMounted, ref } from 'vue'
import VirtualTableVue from "@/components/common/VirtualTable.vue"
import VirtualColumnVue from "@/components/common/VirtualColumn.vue"
import { computed } from '@vue/reactivity';
import { ThemeModule } from '@/store/modules/theme.module';
import OpenTicketReportApi from '@/api/OpenTicketReportApi';

export default defineComponent({
  components: {
    VirtualTableVue,
    VirtualColumnVue
  },
  setup () {
    let timer = 0
    const statusRef = ref<string | null>(null)
    const statusMap = new Map([
      ['null', '全部'],
      ['overflow', '忙碌'],
      ['showBusy', '示忙'],
      ['online', '在线'],
      ['offline', '离线']
    ])
    const statusFilter = computed(() => {
      return (value) => {
        return statusMap.get(value + '')
      }
    })

    const data = ref([]);
    const theme = computed(() => ThemeModule.themeType);

    function statisticsEngineerTicketInfo () {
      OpenTicketReportApi.statisticsEngineerTicketInfo({
        seatStatus: statusRef.value,
        page: {
          pageNumber: 1,
          pageSize: 999
        }
      }).then((res: any) => {
        data.value = res.list || []
        timer = setTimeout(() => {
          statisticsEngineerTicketInfo()
        }, 10000);
      })
    } 

    function setStatus (status: null | 'overflow' | 'showBusy' | 'online' | 'offline') {
      statusRef.value = status
      clearTimeout(timer)
      statisticsEngineerTicketInfo()
    }

    onMounted(() => {
      statisticsEngineerTicketInfo()
    })

    onBeforeUnmount(() => {
      clearTimeout(timer)
    })

    return {
      statusFilter,
      statusRef,
      setStatus,
      theme,
      data
    };
  }
})
